export default "__VITE_ASSET__c02fdd04__"